export const inspectValue = (value: unknown): string => {
  throw new Error("Not supported for the browser. Prefer `debugger;`");
};
